import { render, staticRenderFns } from "./PlayerStep.vue?vue&type=template&id=10cd937c&"
import script from "./PlayerStep.vue?vue&type=script&lang=js&"
export * from "./PlayerStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports